export default "__VITE_ASSET__BkbCKxOI__";